import React from 'react';
import experience from '../data/experience';
import { formatWhen } from '../utils/dateUtils';
import { ExperienceItem } from '../types';

export default function Experience() {
  return (
    <section id="experience">
      <div className="wrap">
        <div className="eyebrow">Professional Experience</div>
        <h2 className="sectitle">Engineering Track Record</h2>
        <p className="secintro">
          Continuous progression across nearly 6 years delivering production AI tooling, high-throughput microservices, cloud migrations, and mission-critical automations for major UK retail systems.
        </p>

        <div className="timeline">
          {experience.map((job: ExperienceItem) => (
            <div className="titem" key={`${job.org}-${job.title}-${job.start}`}>
              <div className="titem-header">
                <div className="when-badge">
                  <span className="live-dot-sub"></span>
                  {formatWhen(job.start, job.end)} · {job.location}
                </div>
                <h3 className="titem-title">{job.title}</h3>
                <div className="org-line">
                  <span className="org">{job.org}</span>
                  {job.tagline && <span className="job-tagline">— {job.tagline}</span>}
                </div>
              </div>

              {job.tags && (
                <div className="job-tags-row">
                  {job.tags.map((t) => (
                    <span className="micro-chip" key={t}>{t}</span>
                  ))}
                </div>
              )}

              <ul className="titem-bullets">
                {job.bullets.map((bullet) => (
                  <li key={`${job.start}-bullet-${bullet.slice(0, 24)}`}>{bullet}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
